import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MQService, ConfigService, MLevelItemsParser} from '@ngxsuit';
import { SYSTEM_CONFIGURATION_ITEM } from 'Admin/interfaces'

declare type CheckSchemaCallback = (navitems: any) => void;


@Injectable()
export class UISchemaService {
    navitems:SYSTEM_CONFIGURATION_ITEM[];
    private bSchemaLoaded = false;
    
    constructor(protected mq:MQService, private http: HttpClient, private config: ConfigService) {
        this.loadSchema();
    }

    public useUISchemaWhenReady(callback: CheckSchemaCallback) {
        if (this.bSchemaLoaded) {
            callback(this.navitems);
        }
    }

    private loadSchema() {
        this.http.get(this.config.getString('base_url') + '/ui/schema').subscribe(
            data=> {
                console.log(this.navitems);
                this.navitems = MLevelItemsParser<SYSTEM_CONFIGURATION_ITEM>([<SYSTEM_CONFIGURATION_ITEM[]>data]);
                this.notifySchemaReady();
            },
            error => {
            }
        );
    }

    private notifySchemaReady() {
        this.bSchemaLoaded = true;
        this.mq.notify('ui-schema-json-ready', {navitems:this.navitems});
    }
}